import strings from "../../i18n/i18nStrings";

export const WHERE_OPTIONS = [
    {
      id: 0,
      text: strings.common.filter.selectOne,
    },
    {
      id: 1,
      key: 'location_id',
      text: strings.common.filter.deviceLocation,
    },
    {
      id: 2,
      key: 'has_water',
      text: strings.common.filter.deviceWater,
    },
    {
      id: 3,
      key: 'has_battery',
      text: strings.common.filter.deviceBattery,
    },
    {
      id: 4,
      key: 'is_online',
      text: strings.common.filter.deviceOnline,
    },
];
